<template>
  <div class="certification-wrapper">
    <div class="certification-widget" v-if="is_items_list_open">
      <!-- Items list -->
      <ul
        class="certification-items"
        v-if="profile_data.certifications.length > 0"
      >
        <li class="certification-starter">
          <div class="certification-item-header">
            <label
              >Certifications ({{
                profile_data.certifications.length | validate
              }})</label
            >
          </div>
        </li>
        <li
          class="certification-item"
          v-for="(item, i) in profile_data.certifications"
          :key="i"
        >
          <panel-expand>
            <template v-slot:header="{ options }">
              <div class="certification-item-header">
                <div class="certification-item-brand">
                  <img src="@/assets/icons/icon__edication.svg" alt />
                </div>
                <div class="content">
                  <div class="title-row">
                    <label>{{ item.name | validate }}</label>
                    <span>{{ item.organization | validate }}</span>
                  </div>
                  <div class="options">
                    <span class="date">
                      <span v-if="item.from">{{
                        item.from | formatDate | validate
                      }}</span>
                    </span>

                    <button
                      class="toogle-panel-btn"
                      @click="options.expanded = !options.expanded"
                      v-if="!options.expanded"
                    >
                      <span class="fa fa-angle-down"></span>
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:main="{ options }">
              <div class="certification-item-body">
                <div class="certification-info">
                  <h5>Description</h5>
                  <p>{{ item.description | validate }}</p>
                </div>
                <div class="certification-item-body-option">
                  <button
                    class="toogle-panel-btn"
                    @click="options.expanded = !options.expanded"
                  >
                    <span
                      class="fa fa-angle-up"
                      v-show="options.expanded"
                    ></span>
                  </button>
                </div>
              </div>
            </template>
          </panel-expand>
        </li>
      </ul>
      <!-- Empty widget -->
      <div class="empty-widget" v-else>
        <div class="empty-widgetheader">
          <label>Certifications</label>
        </div>
        <div class="empty-widget-body">
          <p>No certifications added yet</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dropdownMenu from "@/components/Partials/dropdownMenu";
import appDialog from "@/components/Dialog/AppDialog.vue";
import Datepicker from "vuejs-datepicker";
import upload from "@/components/Partials/Uploader.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import { API } from "@/Store/variable";
import moment from "moment";
import panelExpand from "@/components/Partials/panelExpand";

export default {
  name: "certification",
  components: {
    dropdownMenu,
    appDialog,
    Datepicker,
    upload,
    consultfiedButton,
    panelExpand,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      is_items_list_open: true,

      profile_data: {
        projects: [],
        skills: {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        },
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
        tags: [],
        notifications: [],
        user: {},
        profile: {},
      },
    };
  },
  mounted() {
    let vm = this;
    vm.getProfileData();
  },
  computed: {},
  methods: {
    moment,
    getProfileData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_PROFILE", { id: vm.$route.params.id })
        .then((response) => {
          let data = response.data;
          vm.profile_data = data;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.certification-wrapper {
  @media (min-width: 300px) and (max-width: 630px) {
    padding: 10px;
  }
  .certification-widget {
    width: 100%;
    ul.certification-items {
      padding: 0px 10px;
      padding-bottom: 20px;
      list-style: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      .certification-starter {
        margin-bottom: 6px;
        .certification-item-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 0px;
          label {
            color: #000000;

            font-size: 16px;
          }
          .btn-add {
            color: #1ba5a4;
            border: none;
            padding: 10px 10px;
            font-size: 14px;
            outline: none;
            cursor: pointer;

            font-style: italic;
            background: transparent;
          }
        }
        p {
          color: #131313;
        }
      }
      .certification-item {
        background: #fff;
        border-radius: 5px;
        margin-bottom: 10px;
        position: relative;
        .certification-item-header {
          display: grid;
          padding: 10px 10px;
          grid-template-columns: 90px calc(97% - 90px);
          grid-column-gap: 20px;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 100%;
            grid-column-gap: 10px;
            padding: 10px 12px;
          }
          .certification-item-brand {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 90px;
            background: rgb(228, 228, 228);
            border-radius: 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              width: 60px;
              height: 60px;
              display: none;
            }
            img {
              width: 70px;
              height: 70px;
              object-fit: contain;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 33px;
                height: 33px;
              }
            }
          }

          .content {
            display: flex;
            justify-content: space-between;

            .title-row {
              padding-right: 9px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              label {
                display: block;
                font-size: 14px;

                margin-bottom: 1px;
                font-weight: 800;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }

              span {
                color: #808080;

                font-size: 13px;
                margin-bottom: 6px;
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 12px;
                }
              }
            }
            .options {
              display: flex;
              align-items: flex-end;
              flex-direction: column;
              .btns {
                display: flex;
                margin-top: -11px;
              }
              .verified-status {
                color: #0590ab;
                margin: 10px 0px;
              }
              .btn-verify {
                height: 40px;
                width: 100px;
                outline: none;
                color: #fff;
                background-color: #1890a9;
                border-radius: 5px;
              }
              .date {
                color: #808080;

                font-size: 13px;
                display: flex;
                justify-content: flex-end;
                width: 188px;
                align-items: center;
                margin-bottom: 22px;
                .separator {
                  margin: 0px 5px;
                }
                @media (min-width: 300px) and (max-width: 630px) {
                  font-size: 11px;
                  width: 145px;
                }
              }

              .status {
                color: #000;

                font-size: 13px;
              }

              .toogle-panel-btn {
                width: 19px;
                padding: 0;
                height: 22px;
                font-size: 20px;
                position: absolute;
                bottom: 5px;
                right: 7px;
              }
            }
          }

          .toogle-panel-btn {
            padding: 1px 40px;
            font-size: 30px;
            background: transparent;
            border: none;
            outline: none;
            cursor: pointer;
            color: #ccc;
          }
        }
        .certification-item-body {
          padding: 10px;
          .certification-info {
            h5 {
              text-align: left;
              color: #6e6e6e;
              font-size: 14px;
            }
            p {
              text-align: left;
              color: #000;
              font-size: 13px;
              font-weight: 800;
            }
            .collaboraters-widget {
              padding: 10px 0px;
              display: flex;
              flex-wrap: wrap;
              .item {
                background: #1ba5a4 0% 0% no-repeat padding-box;
                border-radius: 20px;
                display: flex;
                align-items: center;
                padding: 4px 4px;
                margin-right: 8px;
                margin-bottom: 8px;
                .profile-img {
                  width: 26px;
                  height: 26px;
                  border-radius: 50%;
                  margin-right: 5px;
                }
                .name {
                  color: #fff;
                }
              }
            }
            .skills-widget {
              .skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-column-gap: 10px;
                margin-bottom: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;
                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;
                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }
                  .skill_box_body {
                    padding: 0px 15px;
                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 200px;
                      justify-content: center;
                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }
                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }
                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;
                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                        font-weight: 800;
                      }
                    }
                  }
                }
              }
              .next_skills_content__wrapper {
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-column-gap: 10px;
                @media (min-width: 300px) and (max-width: 630px) {
                  grid-template-columns: 1fr;
                }
                .skill_box {
                  min-width: 0;
                  display: flex;
                  flex-direction: column;
                  width: 100%;
                  background: #fff;
                  border-radius: 5px;
                  margin-bottom: 15px;
                  .skill_box_header {
                    border-bottom: 2px solid #f5f5f5;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0px 15px;
                    label {
                      color: #0884af;
                      width: 100%;
                      font-size: 15px;
                      font-weight: 800;
                    }
                  }
                  .skill_box_body {
                    padding: 0px 15px;
                    .empty-skills {
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height: 200px;
                      justify-content: center;
                      p {
                        text-align: center;
                        margin-bottom: 20px;
                        color: #8d8d8d;
                      }
                      button {
                        width: 133px;
                        height: 36px;
                        background: #1890a9 0% 0% no-repeat padding-box;
                        border-radius: 5px;
                        color: #fff;
                      }
                    }
                    .row__item {
                      margin-top: 10px;
                      display: flex;
                      margin-bottom: 10px;
                      justify-content: space-between;
                      width: 100%;
                      span {
                        color: #000000;
                        font-weight: normal;
                        margin-top: 2px;
                        font-size: 14px;
                        font-weight: 800;
                      }
                    }
                  }
                }
              }
            }
          }
          .certification-item-body-option {
            display: flex;
            justify-content: flex-end;
            .toogle-panel-btn {
              padding: 1px 9px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
              height: 36px;
              width: 19px;
              padding: 0;
              height: 22px;
              font-size: 20px;
              position: relative;
              top: -3px;
              right: -5px;
            }
          }
        }
      }
    }

    .empty-widget {
      background: #fff;
      padding: 20px;
      .empty-widget-body {
        height: 350px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          text-align: center;
          width: 270px;
        }
        .add-btn {
          width: 180px;
          height: 45px;
          background: #1890a9 0% 0% no-repeat padding-box;
          border-radius: 4px;
          color: #fff;
          outline: none;
          margin-right: 20px;
          display: center;
          justify-content: center;
        }
      }
    }
  }
  .certification-add-update-widget {
    width: 100%;
    padding: 0px 20px;
    .certification-add-update-header {
    }
    .certification-add-update-body {
      padding-bottom: 10px;
      padding-top: 10px;
      display: flex;
      flex-direction: column;
      label {
        display: block;
      }
      .certification-upload {
        width: 200px;
        margin-bottom: 0px;
      }
      .input-widget {
        margin-bottom: 25px;
        .label {
          display: block;

          margin-bottom: 5px;
          color: #6e6e6e;
        }
        .input {
          display: flex;
          input {
            width: 100%;
            background: #ffffff;
            border: 1px solid #ddd;
            border-radius: 5px;
            padding: 15px 10px;
            font-size: 14px;
            outline: none;
          }
          textarea::placeholder,
          input::placeholder {
            font-style: normal !important;
            color: #707070;
          }
          textarea {
            width: 100%;
            height: 150px;
            background: #ffffff;
            border: 1px solid #ddd;
            border-radius: 5px;
            padding: 15px 10px;
            font-size: 14px;
            outline: none;
          }
        }
        .date-picker {
          width: 100%;
          background: #ffffff;
          border: 1px solid #ddd;
          border-radius: 5px;
          padding: 15px 10px;
          font-size: 14px;
          outline: none;
        }
      }
    }
    .certification-add-update-footer {
      display: flex;
      align-items: center;
      width: 100%;
      .btn-save {
        background: transparent
          linear-gradient(267deg, #1885ad 0%, #04a5a5 100%) 0% 0% no-repeat
          padding-box;
        border-radius: 5px;
        padding: 12px 30px;
        text-decoration: none;
        color: #fff;

        margin-right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .btn-cancel {
        border-radius: 5px;
        padding: 12px 10px;
        text-decoration: none;
        color: #1885ad;

        margin-right: 20px;
      }
    }
  }
  .modal-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: rgba($color: #000000, $alpha: 0.89);
    z-index: 9999;
    display: flex;
    justify-content: center;
    padding-top: 50px;
    padding-bottom: 50px;
    overflow-y: auto;
    .modal {
      width: 600px;
      background: #1ba5a4 0% 0% no-repeat padding-box;
      border-radius: 5px;
      display: inline-table;
      padding-bottom: 10px;
      .modal-header {
        display: flex;
        justify-content: space-between;
        padding: 10px;
        .close-btn {
          color: #fff;
          font-size: 25px;
          outline: none;
          background: transparent;
          border: none;
          cursor: pointer;
        }
      }
      .modal-body {
        padding-left: 40px;
        padding-right: 40px;
        img {
          width: 100%;
        }
      }
      .modal-footer {
        padding: 10px;
        padding-left: 50px;
        padding-right: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .content {
          display: flex;
          flex-direction: column;
          span {
            color: #fff;

            margin-bottom: 7px;
          }
          strong {
            color: #fff;
          }
        }
        .option {
          .download-btn {
            border: 1px solid rgb(247, 247, 247);
            color: #fff;
            padding: 8px 20px;
            text-decoration: none;

            border-radius: 5px;
            font-size: 14px;
            width: 129px;
            display: block;
          }
        }
      }
    }
  }
}
</style>